export enum ReferralTypes {

    GET_REFERRAL_LIST_REQUEST = 'GET_REFERRAL_LIST_REQUEST',
    GET_REFERRAL_LIST_REQUEST_SUCCESS = 'GET_REFERRAL_LIST_REQUEST_SUCCESS',
    GET_REFERRAL_LIST_REQUEST_FAILURE = 'GET_REFERRAL_LIST_REQUEST_FAILURE',

}